import { IProgessBarProps } from "./types";
import ClientCountUp from "./clientCountUp";

export const ProgressBarComponent = ({ pageIndex, totalPages }: IProgessBarProps) => {
  const data = GetProgressBarData(totalPages);
  const countStart = CalculateStartLevel(pageIndex, data.PERCENTAGE_CHANGE);
  const countStop = CalculateStopLevel(pageIndex, data.PERCENTAGE_CHANGE);
  const rate = CalculateFillLevel(pageIndex, 300, data.PERCENTAGE_CHANGE);

  return (
    <div className="flex flex-col items-center justify-center mt-2">
      <div className={`flex border border-greyShadow rounded-lg w-75 bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark`}>
        <div className={`flex justify-center bg-[#2299dd] rounded-lg text-white text-xs`} style={{ width: `${rate}px` }}>
          <ClientCountUp countStart={countStart} countStop={countStop} duration={0.7} />
        </div>
      </div>
    </div>
  );
};

function GetProgressBarData(totalPages: number) {
  const progress = 100 / totalPages;

  return {
    PERCENTAGE_CHANGE: progress,
  };
}

function CalculateFillLevel(progressRate: number, width: number, percentageChange: number) {
  return Math.max((width * (progressRate * percentageChange)) / 100, 25);
}

function CalculateStartLevel(pageIndex: number, percentageChange: number) {
  const maxLevel = 100;
  const startLevel = pageIndex * percentageChange - percentageChange;
  return startLevel > maxLevel ? maxLevel : startLevel;
}

function CalculateStopLevel(pageIndex: number, percentageChange: number) {
  const maxLevel = 100;
  const stopLevel = pageIndex * percentageChange;
  return stopLevel > maxLevel ? maxLevel : stopLevel;
}
